module.exports = __webpack_public_path__ + "media/images/logo-1b61d96d9f56d03b311f5525d2e8a8d7.jpg";